import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import Form from 'react-bootstrap/Form';
import { Button, Col, Container, Row, Modal } from 'react-bootstrap';
import ChemComponent from '../ChemComponent';
import ChemEdit from '../ChemEdit';
import { withRouter } from '../withRouter';
import { encode } from 'html-entities';

class EmailModal extends ChemComponent {
	constructor(props) {
		super(props);

		var email;
		if (props.email) {
			email = this.copyObject(props.email);
			
			// merge in empty values for any missing fields
			this.mergeObject(emptyEmail, email);
		} else {
			email = this.copyObject(emptyEmail);
		}
		
		this.state = {
			email: email,
			renderKey: 0
		};
	}
	
	onChange(accessor, value) {
		var email = this.copyObject(this.state.email);
		this.setByAccessor(email, accessor, value);
		this.mergeState({ email: email });
	}
	
	validateEmail(event, columns, data) {
		return this.validate(columns, data);
	}
	
	onSubmit() {
		var email = this.copyObject(this.state.email);
		email.BODY = encode(email.SALUTATION + ',<br /><br />RE: ' + email.REFERENCE + '<br /><br />' + email.BODY + 
			'<br /><br />Sincerely,<br /><br />' + email.SIGNATURE);
		this.props.onClose(email);
	}
	
	render() {		
		return (
		  <Modal size='xl' show={true} onHide={() => this.props.onClose()}>
			<Modal.Header closeButton>
			  <Modal.Title>Send Job Status to Customer</Modal.Title>
			</Modal.Header>

			<Modal.Body>
				<Container fluid>
				  <Row>
					<Col style={{ paddingTop: '10px', marginBottom: '20px', border: '1px solid #ccc', borderRadius: 6, backgroundColor: '#FEFEFE' }}>
						<ChemEdit parent={this} user={this.props.user} columns={toColumns} data={this.state.email}
						  onChange={(accessor, value) => this.onChange(accessor, value)} renderKey={this.state.renderKey}
						  labelColWidth={6} valueColWidth={6} hideLines={true} />
						<ChemEdit parent={this} user={this.props.user} columns={emailColumns} data={this.state.email}
						  onChange={(accessor, value) => this.onChange(accessor, value)} renderKey={this.state.renderKey}
						  labelColWidth={3} valueColWidth={9} />
						<ChemEdit parent={this} user={this.props.user} columns={enteredColumns} data={this.state.email}
						  onChange={(accessor, value) => this.onChange(accessor, value)} renderKey={this.state.renderKey}
						  labelColWidth={6} valueColWidth={6} hideLines={true} />
						<ChemEdit parent={this} user={this.props.user} columns={signatureColumns} data={this.state.email}
						  onChange={(accessor, value) => this.onChange(accessor, value)} renderKey={this.state.renderKey}
						  validate={(event, columns, data) => this.validateEmail(event, columns, data)}
						  onSubmit={(event) => this.onSubmit()} labelColWidth={3} valueColWidth={9}>
						  <Form.Group as={Row}>
							<Col style={{ borderTop: '1px solid #eee', paddingTop: '5px', marginBottom: '10px' }}>
							  <Button id="send" variant="warning" type="submit" className="float-end">Send</Button>
							</Col>
						  </Form.Group>							
						</ChemEdit>
					</Col>
				  </Row>
				</Container>
			</Modal.Body>
		  </Modal>
		);		
	}
}

const emptyEmail = {
	TO: '',
	REPLY_TO: '',
	CC: '',
	SUBJECT: '',
	REFERENCE: '',
	SALUTATION: '',
	BODY: '',
	ENTERED: '',
	MODIFIED: '',
	SIGNATURE: ''
};

const toColumns = [
	{ Header: 'To', accessor: 'TO', row: 0, col: 0, required: true },
	{ Header: 'Reply To', accessor: 'REPLY_TO', row: 0, col: 1, editable: false }
];

const emailColumns = [
	{ Header: 'CC', accessor: 'CC' },
	{ Header: 'Subject', accessor: 'SUBJECT' },
	{ Header: 'Reference', accessor: 'REFERENCE' },
	{ Header: 'Salutation', accessor: 'SALUTATION' },
	{ Header: 'Text', accessor: 'BODY', type: 'editor' }
];

const enteredColumns = [
	{ Header: 'Job Entered', accessor: 'ENTERED', row: 0, col: 0 },
	{ Header: 'Job Modified', accessor: 'MODIFIED', row: 0, col: 1}
];

const signatureColumns = [
	{ Header: 'Signature', accessor: 'SIGNATURE' }
];

export default withRouter(EmailModal);
